import * as actionTypes from "./ActionTypes"
import { APIGet, APIPost } from "services/APIRequest"
import UrlServer from "configs/UrlServer"

export const listsCallInTypeSub1Update = (callInTypeId,isAdmin = false) => {
  return dispatch => { 
    var url = url = UrlServer.URL_POST_CALL_IN_TYPE_SUB_1
    var body = {statusId:callInTypeId}//callInTypeId
    if(isAdmin){
      url = UrlServer.URL_POST_CALL_IN_TYPE_SUB_1_ADMIN 
    }
    APIPost(url,body, datas => {
      dispatch({ type: actionTypes.LISTS_CALL_IN_TYPE_SUB_1_UPDATE, listsCallInTypeSub1: datas.datas })
    })
  }
}
